import React from 'react';
import { MdClose } from 'react-icons/md';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';

import './index.css';

type PopupProps = {
    title?: string;
    primaryButtonText?: string;
    primaryButtonOnClick?: () => void;
    primaryButtonDisabled?: boolean;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
    children?: React.ReactNode;
    innerRef?: React.RefObject<HTMLDivElement>;
    fullScreen?: boolean;
    closeButtonOnClick?: () => void;
}

function Popup({
    title,
    primaryButtonText,
    primaryButtonOnClick,
    primaryButtonDisabled,
    secondaryButtonText,
    secondaryButtonOnClick,
    children,
    innerRef,
    fullScreen,
    closeButtonOnClick
}: PopupProps) {
    return (
        <>
            <Backdrop />
            <div className={fullScreen ? 'popup--full' : 'popup'} ref={innerRef}>
                <div className='popup__header'>
                    <h1 className='popup__title'>{title}</h1>
                    {closeButtonOnClick && <MdClose className='popup__close' onClick={closeButtonOnClick} />}
                </div>
                {children}
                <div className='popup__buttonGroup'>
                    {primaryButtonText &&
                        <Button
                            className='popup__button'
                            onClick={primaryButtonOnClick}
                            disabled={primaryButtonDisabled}
                        >
                            {primaryButtonText}
                        </Button>
                    }
                    {secondaryButtonOnClick &&
                        <Button
                            className='popup__button'
                            onClick={secondaryButtonOnClick}
                            secondary
                        >
                            {secondaryButtonText}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
}

export default Popup;